// Showroom scene config + catalogue metadata.
export const PHONE = "02 4942 3212";
export const PHONE_TEL = "0249423212";
export const BRAND_LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_spa-showroom/artifacts/nu6ehpez_JS%26O%20New%20Logo%20Pantone.jpg";
export const MAIN_SITE_URL = "https://spasnewcastle.com.au/";

export const CATEGORY_META = {
  spa: { label: "Spas", blurb: "Portable & in-ground spas — Cyclone and Leisurerite ranges." },
  swim_spa: { label: "Swim Spas", blurb: "Swim, train and relax year-round — AquaFit, AquaFit Pro & AquaStream." },
  urban_pool: { label: "Urban Pools", blurb: "Configurable 4m, 6m & 8m lap / plunge pools." },
  sauna: { label: "Saunas", blurb: "Indoor infrared saunas — 1, 2 & 3 person, plug & play." },
};

// Each room's dots are CATEGORY GROUPS (not single products). Tapping a dot deep-links
// to the pre-filtered Range page. Groupings confirmed by the user (see memory/model_list.md).
export const ROOMS = [
  {
    id: "spa",
    category: "spa",
    name: "Spa Range",
    subtitle: "Warm water, under the stars",
    image:
      "https://static.prod-images.emergentagent.com/jobs/37d006de-37ac-493c-88f8-207130788384/images/4ac88394c92ea13273c475de2a25dd74981617ce259af6d2e0c8bbd19b2d8b40.jpeg",
    hotspots: [
      { x: 34, y: 60, label: "1 Massage Bed", query: "beds=1" },
      { x: 62, y: 64, label: "2 Massage Beds", query: "beds=2" },
      { x: 50, y: 44, label: "Massage Seating Only", query: "beds=0" },
    ],
  },
  {
    id: "swim_spa",
    category: "swim_spa",
    name: "Swim Spa Range",
    subtitle: "Endless swim, endless calm",
    image:
      "https://static.prod-images.emergentagent.com/jobs/37d006de-37ac-493c-88f8-207130788384/images/3bd009e775b038a2a9b85d1be556c992537e1de803d479de815da2d03f3c33dc.jpeg",
    hotspots: [
      { x: 42, y: 60, label: "Open Swim Spas (Single Zone)", query: "zone=single" },
      { x: 68, y: 55, label: "Dual Zone Swim Spas", query: "zone=dual" },
    ],
  },
  {
    id: "urban_pool",
    category: "urban_pool",
    name: "Urban Pool Range",
    subtitle: "Overlooking landscaped backyards",
    image:
      "https://static.prod-images.emergentagent.com/jobs/37d006de-37ac-493c-88f8-207130788384/images/f8d17125e3ef86b804c3d73f78a1daf6f42d134e0671ed5554e3482ed5ff17cf.jpeg",
    hotspots: [
      { x: 26, y: 64, label: "Plunge / Swim", query: "config=plunge" },
      { x: 50, y: 56, label: "Open Spa (Single Zone)", query: "config=open" },
      { x: 74, y: 60, label: "Closed Spa (Dual Zone)", query: "config=closed" },
    ],
  },
  {
    id: "sauna",
    category: "sauna",
    name: "Sauna Range",
    subtitle: "Warmth that melts the day away",
    image:
      "https://static.prod-images.emergentagent.com/jobs/37d006de-37ac-493c-88f8-207130788384/images/6fd297822f5d7717611fd99fd12f14923be14f7d89e6086343ef030334a3cadf.jpeg",
    hotspots: [
      { x: 30, y: 56, label: "1 to 2 Person", query: "seats=2" },
      { x: 55, y: 62, label: "2 to 3 Person", query: "seats=3" },
      { x: 76, y: 58, label: "3 to 4 Person", query: "seats=4" },
    ],
  },
];

export const HERO_IMAGE = `${process.env.REACT_APP_BACKEND_URL}/api/media/lifestyle-couple-relax.jpg`;
